import axios from "axios";

export interface User {
  userId: string;
  fullName: string;
  email: string;
  mobilePhones: string;
  address: string;
  firstName: string;
  lastName: string;
  password: string;
  isDeleted: boolean;
  userName: string;
  citizenId: number;
  bankName: string;
  bankBranchNumber: string;
  bankAccountNumber: string;
  ibanNumber: string;
  countryId: number;
  cityId: number;
  avatarPhotoPath?: string;
}

export interface UserLocation {
  citizenId: number;
  firstName: string;
  lastName: string;
  email: string;
  mobilePhones: string;
  address: string;
  notes?: string;
  userId: string;
  password: string;
  userName: string;
  bankName: string;
  bankBranchNumber: string;
  bankAccountNumber: string;
  ibanNumber: string;
  countryId: number;
  cityId: number;
  avatarPhotoPath?: string;
  companyId?: string;
  companyLocationUsers: Partial<UserCompanyLocation>[];
}

export interface UserCompanyLocation {
  companyLocationId: string;
  companyId: string;
  userId: string;
  firstName: string;
  lastName: string;
  userName: string;
  userPhoto: string;
  userLocationPin: string;
  wage: number;
  wageType: number;
  wageTypeName: string;
  userRole: number;
  userRoleName: string;
  isDeleted: boolean;
}

export interface UpdateUserStatus {
  userId: string;
  status: boolean;
}

export async function getUser(userId: string) {
  return axios
    .get<User>(`/Users/getuserbyid/${userId}`)
    .then((res) => res.data);
}

export async function updateUser(user: Partial<User>) {
  return axios.put<User>(`/Users/updateuser`, user).then((res) => res.data);
}

export async function createUserAndLocation(value: Partial<UserLocation>) {
  return axios
    .post<UserLocation>(`/Users/adduserandlocation`, value)
    .then((res) => res.data);
}

export async function updateUserAndLocations(value: Partial<UserLocation>) {
  return axios
    .put<UserLocation>(`/Users/updateuserandlocation`, value)
    .then((res) => res.data);
}

export async function checkUserName(userName: string, locationID: string) {
  return axios
    .get<boolean>(`/Users/checkusername`, {
      params: { UserName: userName, CompanyLocationId: locationID },
    })
    .then((res) => res.data);
}

export async function getLocationsByUser(userId: string) {
  return axios
    .get<User>(`/Users/GetLocationsByUserId/${userId}`)
    .then((res) => res.data);
}

export async function deactivateUser(userID: string) {
  return axios
    .put<string>(`/Users/updateuserstatus`, {
      userId: userID,
      status: true,
    } as UpdateUserStatus)
    .then((res) => res.data);
}

export async function activateUser(userID: string) {
  return axios
    .put<string>(`/Users/updateuserstatus`, {
      userId: userID,
      status: false,
    } as UpdateUserStatus)
    .then((res) => res.data);
}
